<template>
	<div class="ReChannels">
		<div class="card">
			<div class="card-title">
				<h4>Каналы</h4>
				<div class="d-flex">
					<div class="btn-group btn-group-toggle" data-toggle="buttons">
						<label
							v-for="(option, index) in tabs.tabActions"
							:key="option.name"
							class="btn btn-sm btn-primary btn-simple"
							:class="{ active: tabs.activeIndex === index }"
							:id="index"
						>
							<input
								type="radio"
								@click="initTabAction(index)"
								name="options"
								autocomplete="off"
								:checked="tabs.activeIndex === index"
							/>
							<span class="d-none d-sm-block">{{ option.name }}</span>
							<span class="d-block d-sm-none"><i :class="option.icon"></i></span>
						</label>
					</div>

					<div class="createBtn ml-3">
						<base-button type="primary" simple @click="AddChannel()">Создать</base-button>
					</div>
				</div>
			</div>

			<div class="card-body" :class="[isActive ? 'expand-hidden' : 'expand-visible']">
				<base-input
					placeholder="Найти канал"
					addon-left-icon="tim-icons icon-zoom-split"
					v-model="searchText"
					@keyup="getSearch"
					autocomplete="off"
				></base-input>
				<!--пока просто вставила импут, тут быть поиск из  множества каналов ReChannelSmall без дроплиста-->

				<ReChannelSmall
					:title="chan.title"
					v-for="chan in masChannels"
					:key="`${chan.id}_${chan.ch_name}`"
					:description="chan.about"
					:channelIcon="chan.logo"
					:subscribers="chan.participant_count===null?0:chan.participant_count"
					:objChannel="chan"
				/>
			</div>

			<div class="card-footer position-sticky">
				<button class="expandBtn" @click="toggleText()">{{expandText.text}}</button>
			</div>
		</div>
	</div>
</template>

<script>
import ReChannelSmall from "src/our_components/ReChannelSmall.vue";

export default {
	name: "ReChannels",
	components: {
		ReChannelSmall
	},
	props: {
		placeholder: String,
	},
	data() {
		return {
			tabs: {
				activeIndex: 0,
				tabActions: [
					{ name: "Все", icon: "tim-icons icon-world" },
					{ name: "Подписан (а)", icon: "tim-icons icon-bell-55" }
				]
			},
			isActive: true,
			expandText: {
				text: "Показать полностью"
			},
			masChannels:[],
			searchText:'',
			bInSearch: false,
			iApiCallCnt: 0,
			MinTxtLen:2,
		};
	},
	computed: {},
	methods: {
		getSearch(ev){
			if ( this.searchText.length > this.MinTxtLen ){
					this.bInSearch = true;
					this.iApiCallCnt++;
					let iCurApiCallCnt = this.iApiCallCnt;
					this.$GVO.ApiCall('GET',{ obj: "SOC", flt:{list:true,txt:this.searchText}})
						.then((objApi) => { 
							if(objApi.success === true){ //console.log(objApi);
								if ((objApi.data.length > 0) && (this.searchText.length > this.MinTxtLen)){
									if (iCurApiCallCnt == this.iApiCallCnt){
										this.masChannels = [];
										this.bInSearch = false;
										this.masChannels = objApi.data;
										this.iApiCallCnt = 0;
									}
								}else{
									if (iCurApiCallCnt == this.iApiCallCnt) {
										this.bInSearch = false;
										this.masChannels = [];
									}
								}
							}else{
								if (iCurApiCallCnt == this.iApiCallCnt) {
									this.bInSearch = false;
									this.masChannels = [];
								}
							}
						}).catch(errorObjApi => console.error(errorObjApi));
			}else{
				this.masChannels = [];
				this.bInSearch = false;
				this.iApiCallCnt = 0;
				
				if(this.searchText.length == 0){
					this.getChannels();
				}
			}
		},
		getChannels() {
			this.$GVO.ApiCall("GET", { obj: "SOC", flt:{list:true} })
				.then(objApi => {
					if (objApi.success === true) {
						if (objApi.data.length > 0) {
							this.masChannels = objApi.data;
						}
					}
				})
				.catch(errorObjApi => console.error(errorObjApi));
		},
		initTabAction(index) {
			this.tabs.activeIndex = index;
		},
		toggleText(event) {
			this.isActive = !this.isActive;
			if (this.isActive) {
				this.expandText.text = "Показать полностью";
			} else this.expandText.text = "Скрыть";
		},
		AddChannel() {
			this.$router.push({ path: "/data/line/channel/add" });
		}
	},
	mounted() {
		this.getChannels();
	}
};
</script>

<style scoped>
.ReChannels .card {
	padding: 15px 15px 0 15px;
}
.ReChannels .card-body {
	padding: 0;
}
.ReChannels .card-footer {
	padding: 15px;
	border-top: 1px solid #2b3553;
}
.ReChannels .btn-group {
	height: 32px;
	width: 100%;
}
.ReChannels .createBtn {
	width: 100%;
}
.ReChannels .createBtn .btn-simple {
	padding: 4px 22px;
	width: 100%;
}
.expand-hidden {
	height: 32.5rem;
	overflow: hidden;
	margin-bottom: 20px;
}
.expand-visible {
	height: auto;
}
.position-sticky {
	position: sticky;
	bottom: 0;
	z-index: 2;
	background-color: inherit;
}
.expandBtn {
	background-color: transparent;
	border: none;
	outline: none;
	color: #9e77f3;
	padding-left: 0;
}
.expandBtn:hover {
	color: #01b0e0;
}

.ReChannels >>> .btn-sm.btn-simple {padding-top: 6px;}

</style>
